/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Spacer, Text } from '@zapier/design-system';
import { Currency } from '@zapier/currency';

import { CurrencyDropdown } from '@zapier/design-system-revenue/src/components/other/CurrencyDropdown';

const containerStyles = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

type Props = {
  onSelectCurrency: (currency: Currency) => void;
  selectedCurrency: Currency;
};

export const ChangePlanCurrencyDropdown = ({
  onSelectCurrency,
  selectedCurrency,
}: Props) => {
  return (
    <div css={containerStyles}>
      <Text tag="span" type="subtitle700">
        Pay with:
      </Text>
      <Spacer width={10} />
      <CurrencyDropdown
        onSelectCurrency={onSelectCurrency}
        selectedCurrency={selectedCurrency}
      />
    </div>
  );
};
